export type TMeasurementMenuItem = {
  label: string;
  onClick: () => void;
};

/**
 * Builds the "Edit (Measurement Result)" menu item for MeasurementMainMenu
 * (SC_QUICK-2187, QU3DW-1367). Uses the same `${t("EDIT")}(${t("...")})`
 * label pattern as the existing Point Selection / XY plane movement / Z-axis
 * movement items.
 *
 * Pushed unconditionally for every measurement type, by every caller — there
 * is no type or role check gating this item (AC-2: available for all
 * measurement types; AC-13: no role restriction).
 */
export function createMeasurementResultEditMenuItem(
  t: (key: string) => string,
  onSelect: () => void
): TMeasurementMenuItem {
  return {
    label: `${t("EDIT")}(${t("MEASUREMENT_RESULT")})`,
    onClick: onSelect,
  };
}
